import { useState } from "react";
import OverlayGradient from "../../../assets/images/png/home/video/overlay-gradient.svg";
import PauseButtonIcon from "../../../assets/images/png/home/video/pause-btn.svg";
import PlayButtonIcon from "../../../assets/images/png/home/video/play-btn.svg";

import VideoImage1 from "../../../assets/images/png/eyitayo_hero.webp";

import YouTube from "react-youtube";

const TestimonyListVertical = ({ data, selectedVideo, handleSelectVideo }) => {
  return (
    <div className="w-2/12 pl-4 lg:pl-10 space-y-4 individual-video-select-tab">
      {data?.map((datum) => (
        <div
          key={datum?.id}
          onClick={() => handleSelectVideo(datum)}
          className={`cursor-pointer ${
            datum?.id === selectedVideo?.id ? "active" : ""
          }`}
        >
          <img src={datum?.image} alt="" />
        </div>
      ))}
    </div>
  );
};

const GradientOverflowBG = () => {
  return (
    <div className="absolute w-full h-full object-cover top-0 video-gradient">
      <img
        src={OverlayGradient}
        className="w-full h-full object-cover"
        alt=""
      />
    </div>
  );
};

const SelectedVideoInfoWithButton = ({
  selectedVideo,
  show,
  isPaused,
  handlePauseVideo,
  handlePlayVideo,
}) => {
  return (
    <div className="absolute bottom-14 w-full text-center flex flex-col items-center">
      <div className="font-mono font-medium text-xl md:text-3xl text-white mb-6">
        <h3 className="">{selectedVideo?.firstname}</h3>
        <h3 className="">{selectedVideo?.lastname}</h3>
      </div>

      {show && !isPaused ? (
        <div
          id="pauseVideo"
          onClick={handlePauseVideo}
          className="individual-video-play-button text-5xl"
        >
          <img src={PauseButtonIcon} alt="" />
        </div>
      ) : (
        <div
          id="playVideo"
          onClick={handlePlayVideo}
          className="individual-video-play-button text-5xl"
        >
          <img src={PlayButtonIcon} alt="" />
        </div>
      )}
    </div>
  );
};

const YoutubeFrame = ({ options, videoId, onPlay, onPause, onEnd }) => {
  return (
    <YouTube
      title="video"
      videoId={videoId}
      id={"video"}
      opts={options}
      onPlay={onPlay}
      onPause={onPause}
      onEnd={onEnd}
      onReady={(event) => {
        event.target.playVideo();
      }}
    />
  );
};

const HeaderTestimonySection = () => {
  const data = [
    {
      id: 1,
      firstname: "Eyitayo",
      lastname: "Ogunmola",
      image: VideoImage1,
      videoId: "IrwpiqO4YmU",
    },
  ];

  const [selectedVideo, setSelectedVideo] = useState(data[0]);

  const handleSelectVideo = (data) => {
    setSelectedVideo(data);
    setShow(false);
    setIsPaused(false);
  };

  const opts = {
    height: "600",
    width: "100%",
    playerVars: {
      controls: 0,
      autoplay: 1,
      loop: 0,
      disablekb: 1,
      fs: 0,
      modestbranding: 1,
      rel: 0,
      cc_load_policy: 0,
      color: "white",
      iv_load_policy: 3,
      enablejsapi: 1,
      origin: window.location.origin,
      playlist: selectedVideo?.videoId,
    },
  };

  const [show, setShow] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const handlePlayVideo = () => {
    setShow(true);
    setIsPaused(false);
  };

  const handlePauseVideo = () => {
    setIsPaused(true);
  };

  const handleStopVideo = () => {
    setShow(false);
    setIsPaused(false);
  };

  const onPlay = (event) => {
    var pauseButton = document.getElementById("pauseVideo");
    if (show && !isPaused) {
      pauseButton.addEventListener("click", function () {
        event.target.pauseVideo();
      });
    }
  };
  const onPause = (event) => {
    var playButton = document.getElementById("playVideo");
    if (show && isPaused) {
      playButton.addEventListener("click", function () {
        event.target.playVideo();
      });
    }
  };
  const onEnd = (event) => {
    handleStopVideo();
    event.target.stopVideo();
  };

  return (
    <div className="pt-8 lg:px-6  mx-auto relative flex flex-row justify-center lg:justify-end">
      <div className="w-10/12 lg:w-9/12 h-full relative mb-10 lg:mb-0">
        {show ? (
          <YoutubeFrame
            videoId={selectedVideo?.videoId}
            options={opts}
            onPlay={onPlay}
            onPause={onPause}
            onEnd={onEnd}
          />
        ) : (
          <img src={selectedVideo?.image} className="" id="video" alt="" />
        )}
        <GradientOverflowBG />

        <SelectedVideoInfoWithButton
          selectedVideo={selectedVideo}
          show={show}
          isPaused={isPaused}
          handlePlayVideo={handlePlayVideo}
          handlePauseVideo={handlePauseVideo}
        />
      </div>
      <TestimonyListVertical
        data={data}
        selectedVideo={selectedVideo}
        handleSelectVideo={handleSelectVideo}
      />
    </div>
  );
};

export default HeaderTestimonySection;
